let $current: HTMLIFrameElement | null;

export default ($container: HTMLElement) => {
    $current = null;

    $container.querySelectorAll<HTMLButtonElement>('[data-iframe-src]').forEach((btn) => {
        btn.onclick = () => {
            resetEmbed();

            $current = btn.nextElementSibling as HTMLIFrameElement;
            $current.src = btn.dataset.iframeSrc!;
            $current.classList.add('embedded');
            $current.style.display = 'block';
        }
    });
}

export const resetEmbed = () => {
    if ($current) {
        $current.src = '';
        $current.classList.remove('embedded');
        $current.style.display = 'none';
    }
}